import React from 'react';
import HeroSection from '../components/home/HeroSection';
import CategoryShowcase from '../components/home/CategoryShowcase';
import Testimonials from '../components/home/Testimonials';
import GradientCTA from '../components/home/GradientCTA';
import SEO from '../components/common/SEO';

const HomePage: React.FC = () => {
  return (
    <div>
      <SEO
        title="Home"
        description="AI-powered styling for travel, events, and everyday looks. Get personalised outfit plans, packing lists, and expert styling from Suitcase Muse."
        path="/"
      />
      <HeroSection />
      <CategoryShowcase />
      <Testimonials />
      <GradientCTA />
    </div>
  );
};

export default HomePage;
